<template>
  <div class="table-list" v-loading="loading">
    <div class="table-content">
      <el-table
        :data="listData"
        header-cell-class-name="dark"
        :height="tableHeight"
        stripe
        border
        @selection-change="handleSelectionChangePeople"
      >
        <el-table-column type="selection" width="55" />
        <!-- <table-column label="序号" width="60" type="index" /> -->
        <table-column prop="merId" label="档案号" show-overflow-tooltip />
        <table-column
          prop="createTime"
          label="进件时间"
          show-overflow-tooltip
        />
        <table-column prop="merName" label="商户名称" show-overflow-tooltip />
        <table-column prop="corpName" label="法人姓名" show-overflow-tooltip />
        <table-column
          prop="bankAcceptTime"
          label="核准时间"
          show-overflow-tooltip
        />
        <table-column prop="quota" label="授信额度" show-overflow-tooltip />
        <table-column prop="orgName" label="收单机构" show-overflow-tooltip />
        <table-column prop="area" label="城市" show-overflow-tooltip />
        <table-column prop="bankName" label="渠道" show-overflow-tooltip />
        <table-column
          prop="expandUserName"
          label="拓展人员"
          show-overflow-tooltip
        />
        <table-column prop="stateAudit" label="发行类型" show-overflow-tooltip>
          <span slot-scope="{ row }">{{ row.stateAudit | filStateAudit }}</span>
        </table-column>

        <el-table-column width="80" show-overflow-tooltip>
          <div slot="header" class="fixed-right-column">操作</div>

          <router-link
            slot-scope="{ row }"
            :to="`/home/businessIssuance/details/${row.merId}`"
            >查看</router-link
          >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/dataListHeight.js'
export default {
  mixins: [mixin],
  props: {
    listData: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  filters: {
    filStateAudit(value) {
      return {
        '-': '-',
        7: '转移发行（有额度通过）',
        16: '人工复核无额度通过'
      }[value]
    }
  },

  methods: {
    handleSelectionChangePeople(rows) {
      this.$emit('checkboxData', rows)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
